import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './navbar.css';
import { Link } from 'react-router-dom';
const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      setScrolled(isScrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Projects', path: '/projects' },
    { name: 'About', path: '/aboutus' },
    { name: 'Contact', path: '/contactus' },
  ];

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <div className="nav-logo">
          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <span className="logo-text">GLAXMORE</span>
            <span className="logo-tagline">Your Partner in Smarter IT Innovation</span>
          </motion.div>
        </div>

        <div className="nav-menu">
          {navItems.map((item, index) => (
            <a key={index} href={item.path} className="nav-link">
              <motion.span
                whileHover={{ color: "#2563eb" }}
                transition={{ duration: 0.2 }}
              >
                {item.name}
              </motion.span>
            </a>
          ))}
        </div>



        <button 
          className={`mobile-toggle ${isOpen ? 'open' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      <AnimatePresence>
        {isOpen && (
          <motion.div 
            className="mobile-menu"
            initial={{ opacity: 0, x: "100%" }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: "100%" }}
            transition={{ type: "tween", duration: 0.3 }}
          >
            <div className="mobile-menu-content">
              <div className="mobile-menu-header">
                <span className="mobile-logo">GLAXMORE</span>
                <button 
                  className="mobile-close"
                  onClick={toggleMenu}
                  aria-label="Close menu"
                >
                  &times;
                </button>
              </div>
              
              <div className="mobile-nav-items">
                {navItems.map((item, index) => (
                  <a
                    key={index}
                    href={item.path}
                    className="mobile-nav-link"
                    onClick={toggleMenu}
                  >
                    {item.name}
                  </a>
                ))}
              </div>
              
              <div className="mobile-menu-footer">
                <Link to="/contactus">
                <button className="mobile-cta">Let's Talk</button></Link>
                
                <div className="mobile-contact">
<p>
  <a href="tel:+94701111735" style={{ textDecoration: "none", color: "inherit" }}>
    +94 70 1111 735
  </a>
</p>
<p>
  <a href="mailto:info@glaxmore.com" style={{ textDecoration: "none", color: "inherit" }}>
    info@glaxmore.com
  </a>
</p>
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {isOpen && (
          <motion.div 
            className="menu-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.5 }}
            exit={{ opacity: 0 }}
            onClick={toggleMenu}
          />
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;